/**
 *
 * @module playReadyMessage
 *
 */

import Check from 'check-types';
import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    object
} = Check.assert;

/**
 *
 * @class PlayReadyMessage
 * @desc Encapsulates the message sent to the PlayReady license service.
 *
 */
export default class PlayReadyMessage {

    /**
     *
     * @param {PlayReadyMessage} playReadyMessage
     * @param {Object} [body={}]
     * @param {Object} [headers={}]
     * @throws {InvalidArgumentException}
     *
     */
    constructor(body = {}, headers = {}) {

        const errorMessage = {
            ctor: 'PlayReadyMessage(body, headers)',
            get  body() {
                return `${this.ctor} body should be an Object`;
            },
            get headers() {
                return `${this.ctor} headers should be an Object`;
            }
        };

        object(body, errorMessage.body, InvalidArgumentException);
        object(headers, errorMessage.headers, InvalidArgumentException);

        /**
         *
         * @access private
         * @type {Object}
         * @desc The body sent to the getPlayReadyLicense endpoint
         *
         */
        this.body = body;

        /**
         *
         * @access private
         * @type {Object}
         * @desc Map of headers sent to the getPlayReadyLicense endpoint
         *
         */
        this.headers = headers;

    }

}



// WEBPACK FOOTER //
// ./src/services/drm/playReadyMessage.js